import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { ModuleStructure } from "../vo/module-structure";
import { CourseStructure } from "../vo/course-structure";
import { SceneStructure } from "../vo/scene-structure";
import { CoursePage } from "../vo/course-page";
import { Descriptor } from "../vo/descriptor";
import { CourseContext } from "../vo/course-context";
import { ConfigDocModelService } from "app/core/models/config-doc-model.service";
import { CourseScene } from "../vo/course-scene";
import { ApplicationModel } from "./application.model";
import { AppConstants } from "../vo/app-constants";
@Injectable()
export class CourseStructureModelService extends BaseModel {
	private xmlData: any;
	public courseStructure: CourseStructure;
	private sceneSelection: string[] = [];
	private changeSceneList: any[] = [];
	private strCurrentLanguage: string;
	private arrPromise: Promise<any>[] = [];

	constructor(
		private httpService: HttpService,
		private configDocModel: ConfigDocModelService
	) {
		super();
		this.courseStructure = new CourseStructure();
	}

	public initialize(data: any) {
		this.sceneSelection = data.sceneSelection;
		this.strCurrentLanguage = data.language;
		this.changeSceneList = this.configDocModel.getChangeScenesList();
		this.loadBaseConfigXml(data.xmlPath);
		console.log("CourseStructureModelService data.xmlPath  ", data.xmlPath);
	}

	public updateLanguage(strLang: string) {
		this.strCurrentLanguage = strLang;
	}

	public get currentLanguage(): string {
		return this.strCurrentLanguage;
	}

	private loadBaseConfigXml(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			this.xmlData = res;
			this.parseBaseStructure();
		});
	}

	private parseBaseStructure(): void {
		if (this.xmlData.querySelectorAll("course")[0].getAttribute("versionNum"))
			ApplicationModel.instance.contentVersion =
				" | Content " +
				this.xmlData
					.querySelectorAll("course")[0]
					.getAttribute("versionNum")
					.toLowerCase();
		let arrModules = this.xmlData.querySelectorAll("module");
		var iterator: number = 0,
			module,
			moduleStrc: ModuleStructure;
		while ((module = arrModules[iterator++])) {
			moduleStrc = <ModuleStructure>{
				courseModule: {
					module_id: module.getAttribute("id"),
					module_name: module.getAttribute("id"),
					module_selected: false,
					module_open: false,
					module_status: `n`,
				},
				childScenes: this.parseModule(module.querySelectorAll("scene")),
			};
			if (moduleStrc.childScenes.length > 0) {
				this.courseStructure.moduleStructures.push(moduleStrc);
			}
		}
		Promise.all(this.arrPromise).then((values) => {
			this.pruneByFlags();
			this._notifier.next("data");
		});
	}
	public parseBaseStructureAndApplySceneChange() {
		//this.courseStructure = null;
		this.courseStructure = new CourseStructure();
		return new Promise((resolve) => {
			let arrModules = this.xmlData.querySelectorAll("module");
			var iterator: number = 0,
				module,
				moduleStrc: ModuleStructure;
			while ((module = arrModules[iterator++])) {
				moduleStrc = <ModuleStructure>{
					courseModule: {
						module_id: module.getAttribute("id"),
						module_name: module.getAttribute("id"),
						module_selected: false,
						module_open: false,
						module_status: `n`,
					},
					childScenes: this.parseModule(module.querySelectorAll("scene")),
				};
				if (moduleStrc.childScenes.length > 0) {
					this.courseStructure.moduleStructures.push(moduleStrc);
				}
			}

			Promise.all(this.arrPromise).then((values) => {
				this.pruneByFlags();
				resolve(this.courseStructure);
			});
		});
	}

	private pruneByFlags() {
		let flagList = this.configDocModel.flagList;
		this.courseStructure.moduleStructures.forEach((mod) => {
			mod.childScenes.forEach((sce) => {
				sce.childPages.forEach((pge) => {
					if (pge.flags.length > 0) {
						pge.flags.forEach((attr, index) => {
							console.log(attr, index);
							if (
								flagList[attr.name] &&
								attr.value !== flagList[attr.name].value
							) {
								sce.childPages.splice(index, 1);
							}
						});
					}
				});
			});
		});
	}

	private parseModule(arrScenes: Array<any>): SceneStructure[] {
		let sceneArr = [];
		let iterator: number = 0;
		let scene;
		let owner = this;
		while ((scene = arrScenes[iterator++])) {
			if (this.sceneSelection.find((sce) => sce === scene.getAttribute("id"))) {
				let thisScene: SceneStructure = <SceneStructure>{
					courseScene: {
						scene_id: scene.getAttribute("id"),
						scene_name: scene.getAttribute("id"),
						scene_prereq: [],
						scene_selected: false,
						status: "n",
					},
					childPages: [],
				};

				this.arrPromise.push(
					this.getSceneDetails(scene.getAttribute("path")).then(
						function (data) {
							this.childPages = owner.getPagesBylanguage(data);

							owner.changeSceneList.forEach((item) => {
								if (item.id === this.courseScene.scene_id) {
									owner.arrPromise.push(
										owner.getChangeSceneDetails(item.path).then(
											function (cData) {
												let page;
												let changeData =
													owner.pruneChangeSceneByLanguage(cData);
												changeData.forEach((element) => {
													if (element.getAttribute("replaceNode") != null) {
														page = this.childPages.find(
															(cd) =>
																cd.page_id ===
																element.getAttribute("replaceNode")
														);
														if (page) {
															page.page_id = element.getAttribute("id");
															page.page_path = element.getAttribute("path");
															page.page_rubric = element.getAttribute("rubric");
															page.state_specific_content =
																element.getAttribute("stateSpecificContent") ||
																"false";
														}
													} else if (
														element.getAttribute("insertBefore") != null
													) {
														this.childPages = owner.insertBefore(
															this.childPages,
															element
														);
													} else if (
														element.getAttribute("insertAfter") != null
													) {
														this.childPages = owner.insertAfter(
															this.childPages,
															element
														);
													} else if (element.getAttribute("delete") != null) {
														const index = this.childPages.indexOf(page);
														this.childPages = owner.deletePage(
															this.childPages,
															element
														);
													}
												});
											}.bind(this)
										)
									);
									//console.log("Child Pages After",this.childPages);
								}
							});
						}.bind(thisScene)
					)
				);
				//console.log("Scenes added ",thisScene);
				sceneArr.push(thisScene);
			}
		}
		return sceneArr;
	}

	public insertBefore(data, element) {
		let page = data.find(
			(cd) => cd.page_id === element.getAttribute("insertBefore")
		);
		if (page) {
			const index = data.indexOf(page);
			data.splice(index, 0, this.convertToCoursePage(element));
			data[index].deleted = (element.getAttribute("isDeleted"))?((element.getAttribute("isDeleted").toLowerCase() === "true")?true:false):false
		}
		return data;
	}
	public insertAfter(data, element) {
		let page = data.find(
			(cd) => cd.page_id === element.getAttribute("insertAfter")
		);
		if (page) {
			const index = data.indexOf(page);
			data.splice(index + 1, 0, this.convertToCoursePage(element));
			data[index+1].deleted = (element.getAttribute("isDeleted"))?((element.getAttribute("isDeleted").toLowerCase() === "true")?true:false):false
		}
		return data;
	}
	public deletePage(data, element) {
		let page = data.find((cd) => cd.page_id === element.getAttribute("delete"));
		if (page) {
			const index = data.indexOf(page);
			data.splice(index, 1);
		}
		return data;
	}
	private pruneChangeSceneByLanguage(changeList) {
		return changeList.filter(
			(cl) =>
				!cl.getAttribute("language") ||
				String(cl.getAttribute("language")) == this.currentLanguage
		);
		//return changeList.filter((cl) => !cl.getAttribute('language') || String(cl.getAttribute('language')).indexOf(this.currentLanguage) !== -1);
	}
	private getPagesBylanguage(arrpages) {
		return arrpages.filter(
			(page) => String(page.page_language) == this.strCurrentLanguage
		);
		//return arrpages.filter((page) =>   String(page.page_language).indexOf(this.strCurrentLanguage) !== -1);
	}
	private getSceneDetails(url: string): any {
		return new Promise((resolve, reject) => {
			return this.httpService.getXmlData(url).then((res: any) => {
				return resolve(this.parsePageXmlData(res.querySelectorAll("page")));
			});
		});
	}
	private getChangeSceneDetails(url: string): any {
		return new Promise((resolve, reject) => {
			return this.httpService.getXmlData(url).then((res: any) => {
				return resolve(
					Array.prototype.slice.call(res.querySelectorAll("page"))
				);
			});
		});
	}
	private convertToCoursePage(elem: any) {
		const thisPage: CoursePage = <CoursePage>{
			page_id: elem.getAttribute("id"),
			page_language: elem.hasAttribute("language")
				? elem.getAttribute("language")
				: this.strCurrentLanguage,
			page_rubric: elem.getAttribute("rubric"),
			page_path: elem.getAttribute("path"),
			flags: this.getAllFlags(elem),
			state_specific_content:
				elem.getAttribute("stateSpecificContent") || "false",
			status: "n",
			actual_status: "n",
			skippable: false,
			deleted: false
		};
		return thisPage;
	}

	private parsePageXmlData(arrPages: Array<any>): CoursePage[] {
		let arrCoursePage: CoursePage[] = [];
		var iterator: number = 0,
			page;
		while ((page = arrPages[iterator++])) {
			const thisPage: CoursePage = <CoursePage>{
				page_id: page.getAttribute("id"),
				page_language: page.getAttribute("language"),
				page_rubric: page.getAttribute("rubric"),
				page_path: page.getAttribute("path"),
				flags: this.getAllFlags(page),
				state_specific_content:
					page.getAttribute("stateSpecificContent") || "false",
				status: "n",
				actual_status: "n",
				skippable: false,
				deleted: false
			};
			if (!this.isSkippablePage(page)) {
				arrCoursePage.push(thisPage);
			}
		}
		return arrCoursePage;
	}
	/*Methode for checking isSkippableForAdaptive="true",isSkippableForNonAdaptive="true" 
  present in page node .if present then <page> will remove*/
	private isSkippablePage(page: any) {
		let isSkippable: boolean = false;
		if (
			ApplicationModel.instance.adaptiveLearningFlow == AppConstants.ADAPTIVE
		) {
			isSkippable =
				page.hasAttribute("isSkippableForAdaptive") &&
				page.getAttribute("isSkippableForAdaptive").toLowerCase() === "true"
					? true
					: false;
		} else {
			isSkippable =
				page.hasAttribute("isSkippableForNonAdaptive") &&
				page.getAttribute("isSkippableForNonAdaptive").toLowerCase() === "true"
					? true
					: false;
		}
		return isSkippable;
	}
	private getAllFlags(page) {
		let arr = [];
		const flagAttr = page.attributes;
		const nLen = flagAttr.length;
		let attrId;
		for (let i = 0; i < nLen; i++) {
			attrId = flagAttr[i].name;
			if (
				attrId !== "id" &&
				attrId !== "language" &&
				attrId !== "rubric" &&
				attrId !== "path" &&
				attrId !== "stateSpecificContent"
			) {
				arr.push({ name: attrId, value: flagAttr[i].value });
			}
		}
		return arr;
	}

	public addDescriptorToStructure(txtFields: Descriptor[]): void {
		this.courseStructure.moduleStructures.forEach((mod) => {
			mod.courseModule.module_name = this.getDescriptorTextById(
				txtFields,
				mod.courseModule.module_id
			);
			if (mod.childScenes) {
				mod.childScenes.forEach((scene) => {
					scene.courseScene.scene_name = this.getDescriptorTextById(
						txtFields,
						scene.courseScene.scene_id
					);
				});
			}
		});
	}

	private getDescriptorTextById(txtFields: Descriptor[], id: string): string {
		const descriptor: Descriptor = txtFields.find((item) => item.id === id);
		if (descriptor) {
			return descriptor.value;
		}
		return "";
	}

	public get courseStructureVO(): CourseStructure {
		return this.courseStructure;
	}

	public getTotalPagesOfScene(
		moduleNum: number = 0,
		sceneNum: number = 0
	): number {
		return this.courseStructure.moduleStructures[moduleNum].childScenes[
			sceneNum
		].childPages.filter((x) => x.page_language === this.strCurrentLanguage)
			.length;
	}

	public getTotalPagesInCourse(): number {
		var intTotalPages = 0;
		for (let i = 0; i < this.courseStructure.moduleStructures.length; i++) {
			for (
				let j = 0;
				j < this.courseStructure.moduleStructures[i].childScenes.length;
				j++
			) {
				intTotalPages += this.courseStructure.moduleStructures[i].childScenes[
					j
				].childPages.filter(
					(x) => x.page_language === this.strCurrentLanguage
				).length;
			}
		}
		console.log("Total Page in Course ", intTotalPages);
		return intTotalPages;
	}

	public getTotalPagesUptilCurrModuleOrScene(
		moduleNum: number = 0,
		sceneNum: number = 0,
		pageNum: number = 0
	): number {
		var intTotalPages = 0;
		if (moduleNum <= 0) {
			if (sceneNum <= 0) {
				intTotalPages = 0.5; //this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum].childPages.filter(x => x.page_language === this.strCurrentLanguage).length;
			} else {
				for (let i = 0; i < sceneNum; i++) {
					intTotalPages += this.courseStructure.moduleStructures[
						moduleNum
					].childScenes[i].childPages.filter(
						(x) => x.page_language === this.strCurrentLanguage && !x.deleted
					).length;
				}
			}
		} else {
			for (let i = 0; i < moduleNum; i++) {
				for (
					let j = 0;
					j < this.courseStructure.moduleStructures[i].childScenes.length;
					j++
				) {
					intTotalPages += this.courseStructure.moduleStructures[i].childScenes[
						j
					].childPages.filter(
						(x) => x.page_language === this.strCurrentLanguage
					).length;
				}
			}
			if (sceneNum > 0) {
				for (let j = 0; j < sceneNum; j++) {
					intTotalPages += this.courseStructure.moduleStructures[
						moduleNum
					].childScenes[j].childPages.filter(
						(x) => x.page_language === this.strCurrentLanguage
					).length;
				}
			}
		}
		return intTotalPages;
	}

	public updateStatusForJumpToPage(pageid: string): void {
		const nModules: number = this.courseStructure.moduleStructures.length;
		let nScenes: number = 0;
		let nPages: number = 0;
		for (let x = 0; x < nModules; x++) {
			nScenes = this.courseStructure.moduleStructures[x].childScenes.length;
			for (let y = 0; y < nScenes; y++) {
				nPages = this.courseStructure.moduleStructures[x].childScenes[
					y
				].childPages.filter(
					(childPage) => childPage.page_language === this.strCurrentLanguage
				).length;
				for (let z = 0; z < nPages; z++) {
					if (
						pageid ===
						this.courseStructure.moduleStructures[x].childScenes[y].childPages[
							z
						].page_id
					) {
						return;
					}
					this.setPageComplete(
						x,
						y,
						this.courseStructure.moduleStructures[x].childScenes[y].childPages[
							z
						].page_id
					);
				}
			}
		}
	}
	public getCourseModuleDetails(
		moduleNum: number = 0,
		sceneNum: number = 0,
		pageNum: number = 0
	): CourseContext {
		this.setProgress(moduleNum, sceneNum);
		let courseVO: CourseContext = new CourseContext();
		if (
			this.courseStructure.moduleStructures[moduleNum] &&
			this.courseStructure.moduleStructures[moduleNum].courseModule &&
			this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum]
				.courseScene &&
			this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum]
				.childPages.length
		) {
			courseVO.courseModule =
				this.courseStructure.moduleStructures[moduleNum].courseModule;
			courseVO.courseScene =
				this.courseStructure.moduleStructures[moduleNum].childScenes[
					sceneNum
				].courseScene;
			courseVO.coursePage = this.courseStructure.moduleStructures[
				moduleNum
			].childScenes[sceneNum].childPages.filter(
				(x) => x.page_language === this.strCurrentLanguage
			)[pageNum];

			this.courseStructure.moduleStructures.forEach((mod) => {
				if (mod.courseModule.module_id === courseVO.courseModule.module_id) {
					mod.courseModule.module_selected = true;
					mod.courseModule.module_open = mod.childScenes.length > 1;
				} else {
					mod.courseModule.module_selected = false;
					mod.courseModule.module_open = false;
				}
				mod.childScenes.forEach(
					(sce) =>
						(sce.courseScene.scene_selected =
							sce.courseScene.scene_id === courseVO.courseScene.scene_id)
				);
			});
		}

		return courseVO;
	}

	public moduleHasScene(moduleNum: number = 0, sceneNum: number = 0): boolean {
		return (
			this.courseStructure.moduleStructures[moduleNum] &&
			this.courseStructure.moduleStructures[moduleNum].childScenes &&
			this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum] !=
				undefined
		);
	}

	public courseHasModule(moduleNum: number = 0): boolean {
		return this.courseStructure.moduleStructures[moduleNum] != null;
	}

	public setSceneComplete(moduleNum: number = 0, sceneNum: number = 0) {
		this.courseStructure.moduleStructures[moduleNum].childScenes[
			sceneNum
		].courseScene.status = `c`;
	}

	public setModuleComplete(moduleNum: number = 0) {
		this.courseStructure.moduleStructures[
			moduleNum
		].courseModule.module_status = `c`;
	}

	public setPageComplete(
		moduleNum: number = 0,
		sceneNum: number = 0,
		pageId: string
	) {
		const currMod = this.courseStructure.moduleStructures[moduleNum];
		const currScene =
			this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum];

		currMod.courseModule.module_status = "i";
		currScene.courseScene.status = "i";

		currScene.childPages.filter((childPage) => {
			if (childPage.page_id === pageId) {
				childPage.status = "c";
			}
		});
		if (
			currScene.childPages.find((childPage) => childPage.status !== "c") ===
			undefined
		) {
			currScene.courseScene.status = "c";
		}
		if (
			currMod.childScenes.find(
				(childScene) => childScene.courseScene.status !== "c"
			) === undefined
		) {
			currMod.courseModule.module_status = "c";
		}
	}

	public getModules(): any {
		return this.courseStructure.moduleStructures;
	}
	public setProgress(moduleNum: number, sceneNum: number) {
		if (
			this.courseStructure &&
			this.courseStructure.moduleStructures[moduleNum]
		) {
			if (
				this.courseStructure.moduleStructures[moduleNum].courseModule
					.module_status !== `c`
			) {
				this.courseStructure.moduleStructures[
					moduleNum
				].courseModule.module_status = `i`;
			}
			if (
				this.courseStructure.moduleStructures[moduleNum].childScenes[sceneNum]
					.courseScene.status !== `c`
			) {
				this.courseStructure.moduleStructures[moduleNum].childScenes[
					sceneNum
				].courseScene.status = `i`;
			}
		}
	}
	public get structureDocXml(): any {
		return this.xmlData;
	}
}
